<template>
   <div  class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-file-invoice"></i><span> Cotizar</span>
                        <div class="btn-group" role="group">
                            <router-link  :to="'/tratar-datos-clientes'" type="button"  class="btn btn-primary">
                            <i class="far fa-arrow-alt-circle-left"></i> Regresar
                            </router-link>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="shortcode-html">
                            <div class="row border"  style="padding-top:10px">

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                            <label>Cliente</label>

                                            <input type="text" class="form-control bloquear" v-model="vaCreCoti.nombreCliente" id="cliente" v-if="cliente_estado">

                                            <div class="input-group col-xs-12" v-else>
                                                <input type="text" class="form-control bloquear" placeholder="Sin Cliente">
                                                <span class="input-group-append">
                                                    <button class=" btn btn-primary" type="button" @click="abrirModalTipoCliente()">Agregar</button>
                                                </span>
                                            </div>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label>Edad</label>
                                        <input type="text" v-model="vaCreCoti.edadCliente" class="form-control bloquear" id="edad">
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                            <label>Aseguradora</label>

                                            <input type="text" class="form-control bloquear" v-model="cliente_seguro.nombre"  id="seguro" v-if="seguro_estado">

                                            <div class="input-group col-xs-12" v-else>
                                                <input type="text" class="form-control bloquear" placeholder="Sin Aseguradora">
                                                <span class="input-group-append">
                                                    <button class=" btn btn-primary" type="button" @click="abrirModalAseguradora">Agregar</button>
                                                </span>
                                            </div>
                                    </div>
                                </div>


                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label>Tasa %</label>
                                         <money  v-bind="porcentaje_mo" v-model="tasa_automatico"  class="form-control"></money>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label>Año de Antiguedad</label>
                                        <input type="text" class="form-control" v-model="vaCreCoti.anio_antiguedad" id="anio_antiguedad">
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="LeadName">Teléfono Alternativo </label>
                                        <input type="text" v-model="vaCreCoti.telefono_s" class="form-control" placeholder="Ingrese un Nº de Telefono">
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label>Vehiculo</label>
                                        <input type="text" v-if="modelo_estado" class="form-control bloquear" v-model="cliente_vehiculo.nombre" id="vehiculo">
                                        <div class="input-group col-xs-12" v-else>
                                            <input type="text" class="form-control bloquear" placeholder="Sin Vehiculo">
                                            <span class="input-group-append">
                                                <button class=" btn btn-primary" type="button" @click="abrirModalVehiculo()">Agregar</button>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="LeadName">Placa </label>
                                        <input type="text" class="form-control" v-model="vaCreCoti.placa" placeholder="Ingrese un Nº de Placa">
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="estado">Estado</label>
                                        <select class="custom-select" v-model="vaCreCoti.estado">
                                            <option style="color:red;" value="0">Selecione un estado</option>
                                            <option style="color:red;" value="GESTION TELEFONICA">Gestion Telefonica</option>
                                            <option style="color:red;" value="VOLVER A LLAMAR">Volver A Llamar</option>
                                            <option style="color:red;" value="NUMERO INCORRECTO">Numero Incorrecto</option>
                                            <option style="color:red;" value="NO DESEA">No Desea</option>
                                            <option style="color:red;" value="AGENDAR">Agendar</option>
                                            <option style="color:red;" value="CITA">Cita</option>
                                            <option style="color:red;" value="SEGUIMIENTO DE CIERRE">Seguimiento De Cierre</option>
                                            <option value="RECOLECION DE DOCUMENTOS">Recolecion De Documentos</option>
                                            <option value="GESTION DE INSPECCION">Gestion De Inspeccion</option>
                                            <option value="GESTION DE EMISION">Gestion De Emision</option>
                                            <option value="GESTION DE LIBERACION">Gestion De Liberacion</option>
                                            <option value="PRELIQUIDACION">Preliquidacion</option>
                                        </select>
                                    </div>
                                </div>


                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label>Suma Asegurada</label>
                                        <money  v-bind="money" v-model="vaCreCoti.suma_asegurada"  class="form-control"></money>
                                    </div>
                                </div>

                                 <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label>Desgravamen</label>
                                        <money  v-bind="money" v-model="vaCreCoti.desgravamen"  class="form-control"></money>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="estado">Clasificación</label>
                                        <select class="custom-select" v-model="vaCreCoti.idClasificacion">
                                            <option value="0">Selecione una clasificación</option>
                                            <option v-for="cla in clasificacion_list" :key="cla.id" :value="cla.id" v-text="cla.nombre"></option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="Tipo">Tipo de Uso</label>
                                        <select class="custom-select" v-model="vaCreCoti.idTipoUso">
                                            <option value="0">Selecione una Tipo Uso</option>
                                            <option v-for="cla in tipo_uso_list" :key="cla.id" :value="cla.id" v-text="cla.nombre"></option>
                                        </select>
                                    </div>
                                </div>


                                 <div class="col-md-6 col-sm-6 col-lg-4">
                                     <div class="form-group">
                                        <label for="LeadName">Vigencia Inicio</label>
                                        <input type="date" v-model="vaCreCoti.fecha_inicio" class="form-control">
                                     </div>
                                 </div>

                                 <div class="col-md-6 col-sm-6 col-lg-4">
                                     <div class="form-group">
                                        <label for="LeadName">Vigencia Fin</label>
                                        <input type="date" v-model="vaCreCoti.fecha_fin" class="form-control">
                                     </div>
                                 </div>


                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Comentario</label>


                                        <el-input
                                            type="textarea"
                                            placeholder="Comentario"
                                            v-model="tratar_data.comentario"
                                            maxlength="255"
                                            :autosize="{ minRows: 1.3, maxRows: 4}"
                                            clearable
                                            show-word-limit
                                            >
                                        </el-input>
                                    </div>
                                </div>

                                 <div class="col-md-12 col-sm-12 col-lg-12 " align="center">
                                    <h3>ANÁLISIS CUANTITATIVOS - SEGUROS: VEHÍCULOS</h3>
                                </div>
                                <div class="container-fluid scrollTableCotizacion">
                                    <div class="row">
                                            <div class="col-md-6 col-sm-6 col-lg-6 " align="center" v-for="(c, index) in arrayCotizacion" :key="index">
                                                <div class="table-responsive">
                                                            <table class="table table-bordered"  >
                                                            <tbody>

                                                                <tr align="center">
                                                                    <th colspan="5"  scope="colgroup"> <button type="button" @click="eliminar_Detalle_seguro(index)" class="btn btn-danger btn-block"><i class="fas fa-trash-alt"></i> Quitar</button> </th>

                                                                </tr>
                                                                <tr>
                                                                    <td ROWSPAN=3>
                                                                         <template>
                                                                            <div class="center">
                                                                                <h4 for="" style="color: red; font-weight: bold;">Seleccionar? </h4>
                                                                            <vs-checkbox v-model="c.seleccionar">
                                                                                    {{((c.seleccionar==true) ? 'SI': 'NO')}}
                                                                            </vs-checkbox>
                                                                            </div>
                                                                        </template>
                                                                    </td>
                                                                    <th colspan="3" scope="colgroup" ><b v-text="'Seguro:'"></b> <label  v-text="'  '+c.seguro.nombre"></label> </th>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="col" ><b>Tasa</b></th>
                                                                    <th scope="col"  colspan="2" ><b>Prima Neta</b></th>
                                                                </tr>
                                                                <tr>
                                                                   <!--  <th scope="col"  v-text="c.porcentaje_tasa + ' %'">3.20</th> -->
                                                                    <money  v-bind="porcentaje_mo" v-model="c.porcentaje_tasa"  class="form-control"></money>
                                                                    <th scope="col" colspan="2"  v-text="'$ ' + (vaCreCoti.suma_asegurada*c.porcentaje_tasa / 100)"></th>
                                                                </tr>

                                                                <tr>

                                                                    <th scope="row"><b>Desgravamen</b></th>
                                                                    <td v-text="c.seguro.desgravamen + ' %'">56</td>
                                                                    <td colspan="2" v-text=" '$ ' + (c.desgravamen = evaluar_des_por(vaCreCoti.desgravamen, c.seguro.desgravamen))">22</td>

                                                                </tr>
                                                                <tr>

                                                                    <th scope="row" ><b> Auto * Auto</b></th>
                                                                    <td  style="width: 100px;">
                                                                        <template align="center">
                                                                            <div class="center">
                                                                                <label for="" style="color: red; font-weight: bold;">Aplica? </label>
                                                                            <vs-checkbox v-model="c.auto_auto_aplica">
                                                                                    {{((c.auto_auto_aplica) ? 'SI': 'NO')}}
                                                                            </vs-checkbox>
                                                                            </div>
                                                                        </template>
                                                                    </td>
                                                                    <td   v-text="'$ ' + c.seguro.auto_auto" style="width: 100px;">56</td>
                                                                    <td   v-text="((c.auto_auto_aplica) ? '$ ' + c.seguro.auto_auto : '')"  style="width: 100px;">56</td>



                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><b>0 Deducible</b></th>
                                                                    <td  colspan="3" v-text="'$ ' + c.seguro.cero_deducible">56</td>


                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><b>Amparo Patromonial</b></th>
                                                                    <td  colspan="3" v-text="'$ ' + c.seguro.amparo_patrimonial">56</td>


                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><b>Dispositivo de rastreo</b></th>
                                                                    <td  style="width: 100px;">
                                                                        <template align="center">
                                                                            <div class="center">
                                                                                <label for="" style="color: red; font-weight: bold;">Aplica? </label>
                                                                            <vs-checkbox v-model="c.dis_rastreo_aplica">
                                                                                    {{((c.dis_rastreo_aplica==true) ? 'SI': 'NO')}}
                                                                            </vs-checkbox>
                                                                            </div>
                                                                        </template>
                                                                    </td>
                                                                    <td colspan="2" v-text="'$ ' + c.seguro.dispositivo_rastreo">89</td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="col"> </th>
                                                                    <th scope="col" > <b>P .Neta:</b> </th>
                                                                    <th scope="col" colspan="2" v-if="c.auto_auto_aplica" v-text="arrayPrimaNeta[index].prima_neta=(vaCreCoti.suma_asegurada*c.porcentaje_tasa / 100 + parseFloat(c.seguro.auto_auto))"></th>
                                                                    <th scope="col" colspan="2" v-else v-text="arrayPrimaNeta[index].prima_neta=(vaCreCoti.suma_asegurada*c.porcentaje_tasa / 100 )"></th>
                                                                </tr>
                                                                <tr  align="center">
                                                                    <th class="table-primary"  scope="row" colspan="4"><b>Cobertura</b></th>
                                                                </tr>
                                                                <tr v-for="d in c.covertura" :key="d.id">
                                                                    <td scope="row" v-text="d.nombre"></td>
                                                                    <td colspan="3"   align="center" v-if="d.tipo_variable == 'TEXTO' && d.descripcion != ''" v-text="d.descripcion"></td>
                                                                    <td colspan="3"   align="center" v-else-if="d.tipo_variable == 'MONTO' && d.monto != 0" v-text="'US$ ' +  d.monto"></td>
                                                                    <td colspan="3"   align="center" v-else-if="d.tipo_variable == 'PORCENTAJE'" v-text="d.monto + '%'"></td>
                                                                    <td colspan="3"  align="center"  v-else><i class="fas fa-check"></i></td>

                                                                </tr>
                                                                <tr  align="center">
                                                                    <th class="table-primary"  scope="row" colspan="4"><b>Deducible</b></th>
                                                                </tr>
                                                                <tr v-for="d in c.deducible" :key="d.id">
                                                                    <td scope="row" v-text="d.nombre"></td>
                                                                    <td colspan="3"   align="center" v-if="d.tipo_variable == 'TEXTO' && d.descripcion != ''" v-text="d.descripcion"></td>
                                                                    <td colspan="3"   align="center" v-else-if="d.tipo_variable == 'MONTO' && d.monto != 0" v-text="'US$ ' +  d.monto"></td>
                                                                    <td colspan="3"   align="center" v-else-if="d.tipo_variable == 'PORCENTAJE'" v-text="d.monto + '%'"></td>
                                                                    <td colspan="3"  align="center"  v-else><i class="fas fa-check"></i></td>

                                                                </tr>
                                                                <tr>
                                                                    <td><b>PRIMA NETA:</b></td>

                                                                    <th scope="col" colspan="3" v-text="'$ ' + arrayPrimaNeta[index].prima_neta">$ 480</th>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>SUPER BANCOS:</b></td>
                                                                    <td colspan="2">
                                                                        <money  v-bind="porcentaje_mo" v-model="c.s_bancos_por"  class="form-control"></money>
                                                                    </td>
                                                                    <td v-text="c.s_bancos = (arrayPrimaNeta[index].prima_neta * c.s_bancos_por / 100).toFixed(2)"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>S. CAMPESINO:</b></td>
                                                                    <td colspan="2">
                                                                        <money  v-bind="porcentaje_mo" v-model="c.s_campesino_por"  class="form-control"></money>
                                                                    </td>
                                                                    <td v-text="c.s_campesino=(arrayPrimaNeta[index].prima_neta * c.s_campesino_por / 100).toFixed(2)">34</td>
                                                                </tr>
                                                                <tr>
                                                                    <td> <b>S.S.C. NO COBRADO (2001 - 2007):</b></td>
                                                                    <td colspan="2"></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>DERECHOS DE EMISION:</b> </td>

                                                                    <td colspan="3" align="center" v-text=" c.derecho_emicion = evaluar_derecho_emicion(arrayPrimaNeta[index].prima_neta)"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>INTERES DE FINANCIACION: </b></td>
                                                                    <td colspan="2">
                                                                        <money  v-bind="porcentaje_mo" v-model="c.interes_financiamiento_por"  class="form-control"></money>
                                                                    </td>
                                                                    <td v-text="c.interes_financiamiento=((arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino)) *c.interes_financiamiento_por / 100 ).toFixed(2)"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>IVA:</b></td>
                                                                    <td v-text="c.iva_por + ' %'"  colspan="2">34</td>
                                                                    <td v-if="c.interes_financiamiento!=0" v-text="c.iva_total=(parseFloat(c.interes_financiamiento) + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino)).toFixed(2)">34</td>
                                                                    <td v-else v-text="c.iva_total=((arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino))*c.iva_por/100).toFixed(2)">34</td>
                                                                </tr>
                                                                <tr  align="center">
                                                                    <th class="table-primary" scope="row" colspan="4"><b>CON DESCUENTO</b></th>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>VALOR A PAGAR VEHICULO:</b></td>

                                                                    <td v-if="c.interes_financiamiento!=0" colspan="3" v-text="'US$ '+(c.valor_pagar_vehiculo=(arrayPrimaNeta[index].prima_neta +  parseFloat(c.iva_total) + 10).toFixed(2))">34</td>
                                                                    <td v-else colspan="3" v-text="'US$ '+(c.valor_pagar_vehiculo=(arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) +parseFloat(c.s_campesino) + parseFloat(c.derecho_emicion) + parseFloat(c.iva_total)).toFixed(2))">34</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>DESGRAVAMEN:</b></td>

                                                                    <td colspan="3" v-text="'US$ '+c.desgravamen"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>VALOR A PAGAR VEHICULO + DESGRAVAMEN + DISPOSITIVO RASTREO:</b></td>

                                                                    <td colspan="3" v-text="'US$ '+((c.dis_rastreo_aplica==true) ? (c.total = parseFloat(c.valor_pagar_vehiculo) +parseFloat(c.desgravamen) +parseFloat(c.seguro.dispositivo_rastreo)).toFixed(2) : (c.total = parseFloat(c.valor_pagar_vehiculo) +parseFloat(c.desgravamen)).toFixed(2))">34</td>

                                                                </tr>


                                                                </tbody>
                                                            </table>
                                                </div>

                                            </div>
                                    </div>

                                </div>

                            </div>


                            <br>
                            <div class="row">
                                <div class="col-12">
                                    <router-link  :to="'/tratar-datos-clientes'" type="button"  class="btn btn-primary">
                                    <i class="far fa-arrow-alt-circle-left"></i> Regresar
                                    </router-link>
                                    <button type="button" class="btn btn-success" @click="registrarCotizacion()" >Registrar Cotización</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Tipo cliente -->
        <div class="modal fade " :class="{ show: modal_show_tipo_cliente }" :style=" modal_show_tipo_cliente ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title mt-0 font-16" id="myLargeModalLabel" >Seleccionar tipo de Registro</h4>
                        <button type="button" @click="abrirModalTipoCliente" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 form-group">
                                <button type="button" class="btn btn-primary  btn-block" @click="abrirModalNatural(),abrirModalTipoCliente()">Natural</button>
                            </div>

                            <div class="col-md-12 form-group">
                                <button type="button" class="btn btn-primary  btn-block" @click="abrirModalJuridica(),abrirModalTipoCliente()">Juridico</button>
                            </div>

                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalTipoCliente">Cerrar</button>
                    </div>

                </div>
            </div>
        </div>

        <!-- Cliente natural -->
        <div class="modal fade " :class="{ show: modalShowNatural }" :style=" modalShowNatural ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal">Registrar Usuario</h5>
                        <button type="button" @click="abrirModalNatural" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form >
                           <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name" v-model="vaCreCliente.cNombre" placeholder="Ingresa Nombre del Cliente">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido" v-model="vaCreCliente.cApellido" placeholder="Ingresa Apellido del Cliente">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Documento</label>
                                        <select class="custom-select" v-model="vaCreCliente.eIdDocumento" id="status-select">
                                            <option v-for="doc in aTipoDocumento" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                        </select>
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="usuarios">N° Documento</label>
                                                <input type="text" class="form-control" v-model="vaCreCliente.cNumDoc" placeholder="Ingrese número de documento">
                                            </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Dirección</label>
                                        <input type="text" class="form-control" id="direccion" v-model="vaCreCliente.cDireccion" placeholder="Ingrese una Dirección">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Correo Electrónico</label>
                                        <input type="text" class="form-control" id="correo" v-model="vaCreCliente.cEmail" placeholder="Ingresa un Correo Electrónico">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Teléfono </label>
                                        <input type="text" class="form-control" v-model="vaCreCliente.cTelefonoCliente" placeholder="Ingrese un Nº de Teléfono">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="vaCreCliente.fecha_nacimiento" >
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Referencias</label>
                                        <select class="custom-select" v-model="vaCreCliente.referencia" id="status-select">
                                            <option v-for="red in aReferenciasList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Actividad Economica</label>
                                        <select class="custom-select" v-model="vaCreCliente.idactividad_economica" id="status-select">
                                            <option v-for="red in aActividadEconomicaList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre Conyugue</label>
                                        <input type="text" class="form-control" id="name_conyugue" v-model="vaCreCliente.nombre_conyugue" placeholder="Ingresa Nombre del Conyugue">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido Conyugue</label>
                                        <input type="text" class="form-control" id="apellido_conyugue" v-model="vaCreCliente.apellido_conyugue" placeholder="Ingresa Apellido del Conyugue">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Estado Civil</label>
                                        <select class="custom-select" v-model="vaCreCliente.estado_civil" id="status-select">

                                            <option value="Soltero">Soltero</option>
                                            <option value="Casado">Casado</option>
                                            <option value="Divorciado">Divorciado</option>
                                            <option value="Unión libre">Unión libre</option>

                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento Conyugue</label>
                                        <input type="date" class="form-control" v-model="vaCreCliente.fecha_nacimiento_conyugue" >
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="LeadName">Cantidad de Hijos</label>
                                        <input type="number" min="0" class="form-control" id="hijos" v-model="vaCreCliente.hijos_cantidad">
                                    </div>
                                </div>

                                <div class="col-md-2 bloquear">
                                    <div class="form-group">
                                        <label for="LeadName">Edad Conyugue</label>
                                        <input type="text" class="form-control" id="edad_conyugue" :value="calcularEdad(vaCreCliente.fecha_nacimiento_conyugue)">
                                    </div>
                                </div>

                            </div>
                        </form>

                        <form class="g-brd-around g-brd-gray-light-v4">
                             <h4>Nombre de los Hijos</h4>
                            <hr class="g-brd-gray-light-v4 g-mx-minus-30">
                            <div class="row" >
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name_hijo" v-model="dataHijosConyugues.nombre" placeholder="Ingresar Nombre">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido_hijo" v-model="dataHijosConyugues.apellido" placeholder="Ingresar Apellido">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="dataHijosConyugues.fecha_nacimiento" >
                                    </div>
                                </div>
                                 <div class="col-md-12 text-right">
                                   <button type="button" class="btn btn-success mb-2 mr-2" @click="agregarHijosConyugue()">Agregar</button>
                                </div>
                            </div>
                            <div class="table-responsive" style="padding-top: 10ox">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th >Eliminar</th>
                                            <th>Nombre</th>
                                            <th>Apellido</th>
                                            <th>Cumpleaños</th>
                                            <th>Edad</th>
                                        </tr>
                                    </thead>

                                    <tbody v-if="listHijosConyugue.length">
                                        <tr v-for="(c, index) in listHijosConyugue" :key="index">
                                            <td >
                                                <button type="button" @click="eliminar_hijo(index)" class="btn btn-danger btn-block"><i class="fas fa-trash-alt"></i> Quitar</button>
                                            </td>
                                            <td >
                                                <input type="text" class="form-control" v-model="c.nombre" placeholder="Ingresar Nombre">
                                            </td>
                                            <td>
                                                 <input type="text" class="form-control" v-model="c.apellido" placeholder="Ingresar Apellido">
                                            </td>
                                            <td >
                                                 <input type="date" class="form-control" v-model="c.cumpleanio" >
                                            </td>
                                            <td>{{calcularEdad(c.cumpleanio)}} Años</td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td :colspan="9" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-primary" @click="setRegistrarCliente" v-text="nameButon">Guardar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalNatural">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>


         <!--   Inicio modal jurudica-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShowJuridica }" :style=" modalShowJuridica ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal_juri">Seleccionar Tipo de Registro</h4>
                        <button type="button" @click="abrirModalJuridica()" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <h5>Datos Generales</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" >
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Razón Social</label>
                                    <input type="text" class="form-control" id="name" v-model="crear_cliente_juridico.razon_social" placeholder="Ingresar razón social">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Ruc</label>
                                    <input type="text" class="form-control" id="name" v-model="crear_cliente_juridico.ruc" placeholder="Ingresar ruc">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Documento</label>
                                    <select class="custom-select" v-model="crear_cliente_juridico.id_documento" id="status-select">
                                         <option value="0">Seleccionar</option>
                                        <option v-for="doc in aTipoDocumento" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Dirección</label>
                                    <input type="text" class="form-control" id="direccion" v-model="crear_cliente_juridico.direccion" placeholder="Ingrese una dirección">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Correo Electrónico</label>
                                    <input type="text" class="form-control" id="correo" v-model="crear_cliente_juridico.correo" placeholder="Ingrese un correo electrónico">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 1</label>
                                    <input type="text" class="form-control" v-model="crear_cliente_juridico.telefono_1" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 2</label>
                                    <input type="text" class="form-control" v-model="crear_cliente_juridico.telefono_2" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha de Constitución</label>
                                    <input type="date" class="form-control" v-model="crear_cliente_juridico.fecha_constitucion" >
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Actividad Economica</label>
                                    <select class="custom-select" v-model="crear_cliente_juridico.id_actividad_economica" id="status-select">

                                        <option v-for="red in aActividadEconomicaList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Referencia</label>
                                    <select class="custom-select" v-model="crear_cliente_juridico.id_referencia" id="status-select">

                                        <option v-for="red in aReferenciasList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                    </select>
                                </div>
                            </div>

                        </div>
                        <h5>Datos del Representante Legal</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" >
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Nombre</label>
                                    <input type="text" class="form-control" id="name" v-model="crear_representante_legal.nombre" placeholder="Ingrese nombre">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Apellido</label>
                                    <input type="text" class="form-control" id="apellido" v-model="crear_representante_legal.apellido" placeholder="Ingrese apellido">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Documento</label>
                                    <select class="custom-select" v-model="crear_representante_legal.id_documento" id="status-select_2">

                                        <option v-for="doc in aTipoDocumento" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Número de documento</label>
                                    <input type="text" class="form-control" id="apellido" v-model="crear_representante_legal.documento" placeholder="Ingrese apellido">
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Dirección</label>
                                    <input type="text" class="form-control" id="direccion" v-model="crear_representante_legal.direccion" placeholder="Ingrese una dirección">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Correo Electrónico</label>
                                    <input type="text" class="form-control" id="correo" v-model="crear_representante_legal.correo" placeholder="Ingrese un correo electrónico">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 1</label>
                                    <input type="text" class="form-control" v-model="crear_representante_legal.telefono_1" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 2</label>
                                    <input type="text" class="form-control" v-model="crear_representante_legal.telefono_2" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha de Nacimiento</label>
                                    <input type="date" class="form-control" v-model="crear_representante_legal.fecha_nacimiento" >
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Estado Civil</label>
                                    <select class="custom-select" v-model="crear_representante_legal.estado_civil" id="status-select_3">
                                        <option value="Soltero">Soltero</option>
                                        <option value="Casado">Casado</option>
                                        <option value="Divorciado">Divorciado</option>
                                        <option value="Unión libre">Unión libre</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <h5>Datos del Cónyuge</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" >
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Nombre Conyugue</label>
                                    <input type="text" class="form-control" id="name_conyugue" v-model="crear_cliente_juridico.nombre_conyugue" placeholder="Ingresa Nombre del Conyugue">
                                </div>
                            </div>
                            <div class="col-md-4">
                               <div class="form-group">
                                   <label for="LeadName">Apellido Conyugue</label>
                                   <input type="text" class="form-control" id="apellido_conyugue" v-model="crear_cliente_juridico.apellido_conyugue" placeholder="Ingresa Apellido del Conyugue">
                               </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha Nacimiento Conyugue</label>
                                    <input type="date" class="form-control" v-model="crear_cliente_juridico.fecha_nacimiento_conyugue" >
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="LeadName">Cantidad de Hijos</label>
                                    <input type="number"  min="0" class="form-control" id="hijos" v-model="crear_cliente_juridico.hijos_cantidad">
                                </div>
                            </div>
                            <div class="col-md-2 bloquear">
                                <div class="form-group">
                                    <label for="LeadName">Edad Conyugue</label>
                                    <input type="text" class="form-control" id="edad_conyugue" :value="calcularEdad(crear_cliente_juridico.fecha_nacimiento_conyugue)">
                                </div>
                            </div>
                        </div>

                        <h5>Nombre de los Hijos</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row"  >
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name_hijo" v-model="dataHijosConyugues.nombre" placeholder="Ingresar Nombre">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido_hijo" v-model="dataHijosConyugues.apellido" placeholder="Ingresar Apellido">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="dataHijosConyugues.fecha_nacimiento" >
                                    </div>
                                </div>
                                 <div class="col-md-12 text-right">
                                   <button type="button" class="btn btn-success mb-2 mr-2" @click="agregarHijosConyugue()">Agregar</button>
                                </div>
                        </div>
                        <div class="table-responsive" style="padding-top: 10ox">
                                <table class="table table-bordered" >
                                    <thead>
                                        <tr>
                                            <th>Eliminar</th>
                                            <th>Nombre</th>
                                            <th>Apellido</th>
                                            <th>Cumpleaños</th>
                                            <th>Edad</th>
                                        </tr>
                                    </thead>

                                    <tbody v-if="listHijosConyugue.length">
                                        <tr v-for="(c, index) in listHijosConyugue" :key="index">
                                            <td >
                                                <button type="button" @click="eliminar_hijo(index)" class="btn btn-danger btn-block"><i class="fas fa-trash-alt"></i> Quitar</button>
                                            </td>
                                            <td >
                                                <input type="text" class="form-control" v-model="c.nombre" placeholder="Ingresar Nombre">
                                            </td>
                                            <td>
                                                 <input type="text" class="form-control" v-model="c.apellido" placeholder="Ingresar Apellido">
                                            </td>
                                            <td >
                                                 <input type="date" class="form-control" v-model="c.cumpleanio" >
                                            </td>
                                            <td>{{calcularEdad(c.cumpleanio)}} Años</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td :colspan="9" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" @click="setRegistrarClienteJuridico" >Guardar</button>
                        <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalJuridica()">Cerrar</button>
                    </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal jurudica-------------------------------------------------------------->


        <!--   Inicio modal vehivculo-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modal_show_vehiculo }" :style=" modal_show_vehiculo ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel">Registrar Modelo de Vehiculo</h5>
                        <button type="button" @click="abrirModalVehiculo" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form>
                           <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control"  v-model="vaCreModelo.nombre" placeholder="Ingresar Nombre del modelo del vehiculo">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="LeadName">Valor del mercado</label>
                                        <money v-model="vaCreModelo.valor_mercado" v-bind="money"  class="form-control"></money>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="LeadName">Año</label>
                                        <input type="text" class="form-control"  v-model="vaCreModelo.año" placeholder="Ingresar Año">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="categoria">Categoría</label>
                                        <select v-model="vaCreModelo.categoria"  class="custom-select" >
                                            <option value="0">Selecione una Categoría</option>
                                            <option v-for="cate in arrayCategoria" :key="cate.id" :value="cate.id" v-text="cate.nombre"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="categoria">Marca</label>
                                        <select v-model="vaCreModelo.marca"  class="custom-select" >
                                            <option value="0">Selecione una Marca</option>
                                            <option v-for="cate in arrayMarca" :key="cate.id" :value="cate.id" v-text="cate.nombre"></option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="categoria">Tipo de Vehiculo</label>
                                        <select v-model="vaCreModelo.tipo_vehiculo"  class="custom-select" >
                                            <option value="0">Selecione un Tipo de Vehiculo</option>
                                            <option v-for="cate in arrayTipoVehiculo" :key="cate.id" :value="cate.id" v-text="cate.nombre"></option>
                                        </select>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button"  class="btn btn-sm btn-primary" @click="setRegistrarModelo">Guardar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalVehiculo">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal vehivculo-------------------------------------------------------------->

         <!-- Tipo aseguradora -->
        <div class="modal fade " :class="{ show: modal_show_aseguradora }" :style=" modal_show_aseguradora ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title mt-0 font-16" id="myLargeModalLabel" >Seleccionar Aseguradora</h4>
                        <button type="button" @click="abrirModalAseguradora" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">

                                <div class="col-md-12 col-sm-12 col-lg-12">
                                    <div class="form-group">
                                        <label for="Tipo">Seguro</label>
                                        <select  v-model="cliente_seguro.id" class="custom-select">
                                            <option value="0"> Selecionar</option>
                                            <option v-for="cla in arraySeguro" :key="cla.id" :value="cla.id" v-text="cla.nombre"></option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-lg-12">
                                    <div class="form-group">
                                        <label for="estado">Tasas</label>
                                        <money  v-bind="porcentaje_mo" v-model="tasa_automatico"  class="form-control"></money>

                                    </div>
                                </div>


                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" @click="setRegistraSeguro()">Guardar</button>
                        <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalAseguradora">Cerrar</button>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {alertasM} from '../../../util.js';
export default {
    props: ['ruta', 'iva_data'],
    data(){
        return{
            id              : this.$attrs.id, //Id cliente data
            cliente         : [],
            clasificacion_list  : [],
            tipo_uso_list       : [],
            cliente_estado  : false,
            seguro_estado   : false,
            modelo_estado   : false,

            cliente_seguro : {
                id                  : 0,
                nombre              : '',
                logo                : null,
                desgravamen         : 0,
                cero_deducible      : 0,
                amparo_patrimonial  : 0,
                auto_auto           : 0,
                dispositivo_rastreo : 0,
            },

            cliente_vehiculo: {
                id              : 0,
                nombre          : '',
                anio            : 0,
                valor_mercado   : 0,
                anio_antiguedad : 0,
            },
            money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
            },
            data:{
                clasificacion_id : 0,
                tipo_uso_id      : 0,
                desgravamen      : 0
            },

            tratar_data :{
                id                  : 0,
                asesor              : '',
                iduser              : 0,
                fecha_gestion       : null,
                vigencia_depoliza   : null,
                estado              : '',
                comentario          : '',
                cliente             : '',
                telefono_1          : '',
                telefono_2          : null,
                cedula              : '',
                fecha_nacimiento    : null,
                direccion           : '',
                email               : null,
                aseguradora         : "",
                ramo                : '',
                marca               : '',
                modelo              : '',
                anio                : '',
                placa               : '',
                valor_asgurado      : 0,
                tasa                : 0.00,
                prima_neta          : 0,
                forma_pago          : '',
                comision            : 0,
            },
            //Cliente
            modal_show_tipo_cliente : false,
            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            modalShowNatural : false,
            modalShowJuridica: false,
            aTipoDocumento: [],
            aReferenciasList: [],
            aActividadEconomicaList: [],
            tituloModal      : 'Registrar',
            actu_reg         : 1,
            nameButon        : 'Guardar',

            vaCreCliente:{
                eId: 0,
                cNombre: '',
                cApellido: '',
                fecha_nacimiento: null,
                cNumDoc: '',
                eIdDocumento: 1,
                cDireccion: '',
                cTelefonoCliente: '',
                cEmail: '',
                referencia: 0,
                idactividad_economica: 0,
                estado_civil: '',
                hijos_cantidad: 0 ,
                nombre_conyugue: '',
                apellido_conyugue: '',
                fecha_nacimiento_conyugue: null,
                tipo                      : 1
            },
            crear_cliente_juridico:{
                id                          : 0,
                razon_social                : '',
                ruc                         : '',
                direccion                   : '',
                correo                      : '',
                id_documento                : 3,
                telefono_1                  : '',
                telefono_2                  : '',
                fecha_constitucion          : null,
                id_actividad_economica      : 0,
                id_referencia               : 0,
                tipo                        : 2,
                nombre_conyugue             : '',
                apellido_conyugue           : '',
                fecha_nacimiento_conyugue   : null,
                hijos_cantidad              : 0
            },
            crear_representante_legal: {
                id                  : '',
                nombre              : '',
                apellido            : '',
                documento           : '',
                id_documento        : 0,
                direccion           : '',
                correo              : '',
                telefono_1          : '',
                telefono_2          : '',
                fecha_nacimiento    : null,
                estado_civil        : '',

            },
            dataHijosConyugues:{
                id: 0,
                nombre: '',
                apellido: '',
                fecha_nacimiento: null
            },
            tituloModal_juri: '',
            nameButon_juri: '',
            actu_reg_juri: 0, //0 registrar - 1 actualizar
            listHijosConyugue: [],
            //Vehiculo
            modal_show_vehiculo : false,
            vaCreModelo:{
                eId: 0,
                nombre: '',
                state: '',
                categoria: 0,
                marca: 0,
                tipo_vehiculo: 0,
                año: '',
                valor_mercado: 0.0,
            },
            arrayMarca: [],
            arrayCategoria: [],
            arrayTipoVehiculo: [],

            modal_show_aseguradora: false,

            porcentaje_mo: {
                    decimal: '.',
                    thousands: '',
                    prefix: '',
                    suffix: ' %',
                    precision: 2,
                    masked: false
            },
            tasa_automatico: 0,
            arraySeguro: [],
            arrayCotizacion:[],
            arrayPrimaNeta: [],

            //Cotizacion
            vaCreCoti: {

                idcliente: 0,
                nombreCliente: '',
                edadCliente: 0,

                suma_asegurada: 0.0,
                idVehiculo: 0,
                nombreVehiculo: '',
                estado: 0,

                idClasificacion: 0,
                desgravamen: 0.0,
                idTipoUso: 0.0,

                fecha_inicio: null,
                fecha_fin: null,
                placa: '',
                telefono_s: '',
                comentario: '',
                anio_antiguedad: 0,
                iduser: 0,

            },


        }
    },
    mixins: [alertasM],
    methods:{

        clienteCotizar(){
            let me = this;
            me.openCargando();
            var url = '/tratar-data-clientes-cotizar/cotizar';

            axios.post(url,{
                id: me.id
            })
            .then(res => {
                let respuesta = res.data;

                me.cliente          = respuesta.cliente;


                me.clasificacion_list       = respuesta.clasificacion;
                me.tipo_uso_list            = respuesta.tipo_uso;
                me.aTipoDocumento           = respuesta.documento;
                me.aReferenciasList         = respuesta.referencia;
                me.aActividadEconomicaList  = respuesta.actividadeconomica;

                me.arrayMarca               = respuesta.marca;
                me.arrayCategoria           = respuesta.categoria;
                me.arrayTipoVehiculo        = respuesta.tipo_vehiculo;
                me.arraySeguro              = respuesta.tipo_seguro;


                me.cliente_estado           = me.cliente.tranferencia.cliente;
                me.seguro_estado            = me.cliente.tranferencia.seguro;
                me.modelo_estado            = me.cliente.tranferencia.modelo;

                me.data.clasificacion_id    = (me.cliente.tranferencia.clasificacion_id == null) ? 0 : me.cliente.tranferencia.clasificacion_id;
                me.data.tipo_uso_id         = (me.cliente.tranferencia.tipo_uso_id == null) ? 0 : me.cliente.tranferencia.tipo_uso_id;
                me.data.desgravamen         = me.cliente.tranferencia.desgravamen;

                me.vaCreCoti.idClasificacion        = me.cliente.tranferencia.clasificacion_id;
                me.vaCreCoti.desgravamen            = (me.cliente.tranferencia.desgravamen == null) ? 0 : me.cliente.tranferencia.desgravamen;
                me.vaCreCoti.idTipoUso              = me.cliente.tranferencia.tipo_uso_id;

                me.vaCreCoti.estado         = me.cliente.estado;



                //bjar

                if (me.cliente_estado) {
                    me.vaCreCoti.idcliente          = respuesta.cliente_cotizacion.id;
                    me.vaCreCoti.nombreCliente      = respuesta.cliente_cotizacion.nombre;
                    me.vaCreCoti.edadCliente        = respuesta.cliente_cotizacion.edad;
                }

                if(me.seguro_estado){
                   me.cliente_seguro = {
                        id                  :  respuesta.cliente_seguro.id,
                        nombre              :  respuesta.cliente_seguro.nombre,
                        logo                :  respuesta.cliente_seguro.logo,
                        desgravamen         :  respuesta.cliente_seguro.desgravamen,
                        cero_deducible      :  respuesta.cliente_seguro.cero_deducible,
                        amparo_patrimonial  :  respuesta.cliente_seguro.amparo_patrimonial,
                        auto_auto           :  respuesta.cliente_seguro.auto_auto,
                        dispositivo_rastreo :  respuesta.cliente_seguro.dispositivo_rastreo,
                    };

                    this.tasas_seguro_agregar();

                }

                if(me.modelo_estado){
                    let me = this;
                    var anio_actual = new Date().getFullYear();

                    me.cliente_vehiculo = {
                        id              : respuesta.cliente_vehiculo.id,
                        nombre          : respuesta.cliente_vehiculo.nombre,
                        anio            : respuesta.cliente_vehiculo.año,
                        valor_mercado   : respuesta.cliente_vehiculo.valor_mercado,
                        anio_antiguedad : (anio_actual - respuesta.cliente_vehiculo.año)
                    };

                    me.vaCreCoti.suma_asegurada     = respuesta.cliente_vehiculo.valor_mercado;
                    me.vaCreCoti.idVehiculo         = respuesta.cliente_vehiculo.id;
                    me.vaCreCoti.nombreVehiculo     = respuesta.cliente_vehiculo.nombre;


                }



                //Tratamiento de datos

                me.tratar_data.placa                    = me.cliente.placa;
                me.tratar_data.comentario               = me.cliente.comentario;
                me.tratar_data.fecha_gestion            = me.cliente.fecha_gestion;
                me.tratar_data.vigencia_depoliza        = me.cliente.vigencia_depoliza;
                me.tratar_data.telefono_1               = me.cliente.telefono_1;
                me.cliente_vehiculo.valor_mercado       = (me.cliente.valor_asgurado != null && me.cliente.valor_asgurado != '') ? me.cliente.valor_asgurado : 0;
                me.vaCreCoti.suma_asegurada             = me.cliente_vehiculo.valor_mercado;
                //Cliente datos
                me.vaCreCliente.cNombre                 = me.cliente.cliente;
                me.vaCreCliente.cNumDoc                 = me.cliente.cedula;
                me.vaCreCliente.cDireccion              = me.cliente.direccion;
                me.vaCreCliente.cEmail                  = me.cliente.email;
                me.vaCreCliente.cTelefonoCliente        = me.cliente.telefono_1;
                me.vaCreCliente.fecha_nacimiento        = me.cliente.fecha_nacimiento;

                //Cotizacion

                me.vaCreCoti.fecha_inicio       = me.cliente.fecha_gestion;
                me.vaCreCoti.fecha_fin          = me.cliente.vigencia_depoliza;
                me.vaCreCoti.placa              = me.cliente.placa;
                me.vaCreCoti.telefono_s         = me.cliente.telefono_1;
                me.vaCreCoti.comentario         = me.cliente.comentario;
                me.vaCreCoti.anio_antiguedad    = me.cliente_vehiculo.anio_antiguedad;




               /* me.crear_cliente_juridico.razon_social          = me.cliente.cliente;
                me.crear_cliente_juridico.ruc                   = me.cliente.cedula;
                me.crear_cliente_juridico.direccion             = me.cliente.direccion;
                me.crear_cliente_juridico.correo                = me.cliente.email;
                me.crear_cliente_juridico.telefono_1            = me.cliente.telefono_1;
                me.crear_cliente_juridico.telefono_2            = me.cliente.telefono_2;
                me.crear_cliente_juridico.fecha_constitucion    = me.cliente.fecha_nacimiento;*/

                //vEHICULO

                me.vaCreModelo  = {
                        eId             : 0,
                        nombre          : me.cliente.modelo,
                        state           : '',
                        categoria       : 0,
                        marca           : 0,
                        tipo_vehiculo   : 0,
                        año             : me.cliente.anio,
                        valor_mercado   : me.cliente.valor_asgurado,
                };

                me.tasa_automatico = (me.cliente.tasa == null ) ? 0 :me.cliente.tasa;



                //Actualziar suma asegurada -> anotacion
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                }
                console.error(err);
            })
        },

        abrirModalTipoCliente() {
            this.modal_show_tipo_cliente = !this.modal_show_tipo_cliente;
        },

        abrirModalNatural() {
            this.modalShowNatural = !this.modalShowNatural;

            if(this.modalShowNatural==true){

                this.tituloModal = "Registrar Cliente Natural";
                this.actu_reg = 0;
                this.nameButon = "Guardar";

            }else{

                this.cleanVariables();
            }
        },

        cleanVariables(){
            this.vaCreCliente.cNombre = "";
            this.vaCreCliente.referencia = "";
            this.vaCreCliente.cApellido = "";
            this.vaCreCliente.fecha_nacimiento = "";
            this.vaCreCliente.eId = "";
            this.vaCreCliente.cNumDoc = "";
            this.vaCreCliente.eIdDocumento = 1;
            this.vaCreCliente.referencia = 1;
            this.vaCreCliente.cDireccion = "";
            this.vaCreCliente.cTelefonoCliente = "";
            this.vaCreCliente.cEmail = "";
            this.vaCreCliente.idactividad_economica = 0;
            this.vaCreCliente.estado_civil = '';
            this.listHijosConyugue = [];
            this.vaCreCliente.hijos_cantidad = 0 ;
            this.vaCreCliente.nombre_conyugue = '';
            this.vaCreCliente.apellido_conyugue = '';
            this.vaCreCliente.fecha_nacimiento_conyugue = null;
            this.modalShowNatural = false;

        },

        calcularEdad(fecha) {
            if(fecha===null || fecha === ''){
                     return 0;
            }
            var hoy = new Date();
            var cumpleanos = new Date(fecha);
            var edad = hoy.getFullYear() - cumpleanos.getFullYear();
            var m = hoy.getMonth() - cumpleanos.getMonth();

            if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
                edad--;
            }
            if(edad < 0) {edad = 0;}

            return edad;
        },

        agregarHijosConyugue(){
            if(this.dataHijosConyugues.nombre === '' || this.dataHijosConyugues.apellido === '' || this.dataHijosConyugues.fecha_nacimiento === null ){
                this.notify(" " + 'Ingrese todos los datos del hijo a registrar',"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
            }else{
                this.listHijosConyugue.push({
                    'id' : 0,
                    'nombre': this.dataHijosConyugues.nombre,
                    'apellido': this.dataHijosConyugues.apellido,
                    'cumpleanio' : this.dataHijosConyugues.fecha_nacimiento
                });

                this.dataHijosConyugues.nombre = '';
                this.dataHijosConyugues.apellido = '';
                this.dataHijosConyugues.fecha_nacimiento = null;
            }
        },

        eliminar_hijo(index){
            let me = this;
            me.listHijosConyugue.splice(index, 1);
        },

        setRegistrarCliente(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/cliente/registrar';

            axios.post(url, {
                'nombre' :                  this.vaCreCliente.cNombre,
                'referencia' :              this.vaCreCliente.referencia,
                'apellido' :                this.vaCreCliente.cApellido,
                'documento':                this.vaCreCliente.eIdDocumento,
                'idreferencia':             this.vaCreCliente.referencia,
                'numdoc':                   this.vaCreCliente.cNumDoc,
                'direccion':                this.vaCreCliente.cDireccion,
                'telefono':                 this.vaCreCliente.cTelefonoCliente,
                'fecha_nacimiento':         this.vaCreCliente.fecha_nacimiento,
                'email':                    this.vaCreCliente.cEmail,
                'idactividad_economica':    this.vaCreCliente.idactividad_economica,
                'estado_civil':             this.vaCreCliente.estado_civil,
                'hijos_cantidad':           this.vaCreCliente.hijos_cantidad,
                'nombre_conyugue':          this.vaCreCliente.nombre_conyugue,
                'apellido_conyugue':        this.vaCreCliente.apellido_conyugue,
                'fecha_nacimiento_conyugue': this.vaCreCliente.fecha_nacimiento_conyugue,
                'arrayHijosConyugue' :      this.listHijosConyugue,
                'clientes_data_id'   :      this.id

            }).then(res => {

                if(res.data.status){

                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.cleanVariables();//Limpiamos el form
                    this.clearVariablesJuridico();
                    this.clienteCotizar();
                    this.notify(" Cliente registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')

                }else if(res.data.errorTipo) {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.notify(" Seleccione almenos un tipo de cliente","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })
        },

        setRegistrarClienteJuridico(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/cliente/registrar-juridico';
            let me = this;

            axios.post(url, {
                'datos_general'         : me.crear_cliente_juridico,
                'representante_legal'   : me.crear_representante_legal,
                'hijos'                 : me.listHijosConyugue,
                'clientes_data_id'      : me.id
            }).then(res => {

                if(res.data.status){

                   this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.cleanVariables();//Limpiamos el form
                    this.clearVariablesJuridico();
                  if(this.actu_reg==1){
                       this.notify(" Cliente registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                       this.clienteCotizar();
                  }else{
                       this.notify(" Cliente actualizado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                  }

                }else{
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.notify("Error","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })
        },

        abrirModalJuridica() {
            this.modalShowJuridica = !this.modalShowJuridica;

            if(this.modalShowJuridica==true){

                this.tituloModal_juri = "Registrar Cliente Juridico";
                this.actu_reg_juri = 0;

            }else{
                this.detalle_2 = false;
                this.cleanVariables();
                this.clearVariablesJuridico();//Limpiamos el form
            }
        },

        clearVariablesJuridico(){
            this.modalShowJuridica  = false;
            this.crear_cliente_juridico.razon_social                = '';
            this.crear_cliente_juridico.ruc                         = '';
            this.crear_cliente_juridico.direccion                   = '';
            this.crear_cliente_juridico.correo                      = '';
            this.crear_cliente_juridico.id_documento                = 3;
            this.crear_cliente_juridico.telefono_1                  = '';
            this.crear_cliente_juridico.telefono_2                  = '';
            this.crear_cliente_juridico.fecha_constitucion          = null;
            this.crear_cliente_juridico.id_actividad_economica      = 0;
            this.crear_cliente_juridico.id_referencia               = 0;
            this.crear_cliente_juridico.tipo                        = 2;
            this.crear_cliente_juridico.nombre_conyugue             = '';
            this.crear_cliente_juridico.apellido_conyugue           = '';
            this.crear_cliente_juridico.fecha_nacimiento_conyugue   = null;
            this.crear_cliente_juridico.hijos_cantidad              = 0;

            this.crear_representante_legal.nombre              = '';
            this.crear_representante_legal.apellido            = '';
            this.crear_representante_legal.documento           = '';
            this.crear_representante_legal.id_documento        = 0;
            this.crear_representante_legal.direccion           = '';
            this.crear_representante_legal.correo              = '';
            this.crear_representante_legal.telefono_1          = '';
            this.crear_representante_legal.telefono_2          = '';
            this.crear_representante_legal.fecha_nacimiento    = null;
            this.crear_representante_legal.estado_civil        = '';

            this.listHijosConyugue = [];
            this.vaCreCliente.hijos_cantidad = 0 ;
            this.vaCreCliente.nombre_conyugue = '';
            this.vaCreCliente.apellido_conyugue = '';
            this.vaCreCliente.fecha_nacimiento_conyugue = null;
        },

        abrirModalVehiculo() {
            this.modal_show_vehiculo = !this.modal_show_vehiculo;

            if(this.modal_show_vehiculo==true){

            }else{
               // this.aTipoDocumento = [];
                this.cleanVehiculosVariables();
            }
        },

        cleanVehiculosVariables(){
            this.vaCreModelo  = {
                        eId             : 0,
                        nombre          : me.cliente.modelo,
                        state           : '',
                        categoria       : 0,
                        marca           : 0,
                        tipo_vehiculo   : 0,
                        año             : me.cliente.anio,
                        valor_mercado   : me.cliente.valor_asgurado,
                };
        },

        setRegistrarModelo(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/modelo/registrar';


            axios.post(url, {
                'nombre' : this.vaCreModelo.nombre,
                'categoria' : this.vaCreModelo.categoria,
                'marca' : this.vaCreModelo.marca,
                'tipo_vehiculo' : this.vaCreModelo.tipo_vehiculo,
                'año' : this.vaCreModelo.año,
                'valor_mercado' : this.vaCreModelo.valor_mercado,
                'clientes_data_id'   :      this.id
            }).then(res => {

                this.cleanVehiculosVariables();//Limpiamos el form
                this.clienteCotizar();
                this.modal_show_vehiculo=false;

                if(res.data.status){

                    this.notify(" Modelo de Vehiculo registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                console.error(err);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
              if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
            })
        },

        abrirModalAseguradora() {
            this.modal_show_aseguradora = !this.modal_show_aseguradora;

            if(this.modal_show_aseguradora==true){
                if(this.cliente.tasa == null){
                    this.tasa_automatico =  this.calcular_tasas(this.vaCreCoti.edadCliente, this.cliente_vehiculo.anio_antiguedad, this.cliente_vehiculo.valor_mercado);
                }


            }
        },

        calcular_tasas(edad_v, antiguedad_v, valor_asegurado_v){
            let edad = edad_v
            let antiguedad = antiguedad_v
            let valor_asegurado = valor_asegurado_v

            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.70
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.80
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.90
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.00
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.10

            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.35
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.40
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.45
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.50

            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.40
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.45
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.50
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.60

            if(edad >= 18 && edad <= 25  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.30

            if(edad >= 18 && edad <= 25  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29999)  return 5.00

            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.60
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.70
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.80
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.90
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.00

            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.25
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.30
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.35
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.40
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.45

            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.35
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.40
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.45
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.50

            if(edad >= 26 && edad <= 32  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.20

            if(edad >= 26 && edad <= 32  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.80

            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.50
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.60
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.70
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.80
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 2.90

            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.20
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.25
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.30
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.35
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.40

            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.25
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.30
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.35
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.40
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.45

            if(edad >= 33 && edad <= 40  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.10

            if(edad >= 33 && edad <= 40  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.70

            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.40
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.50
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.60
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.70
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 2.80

            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.10
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.20
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.25
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.30
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.35

            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.20
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.25
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.00
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.35
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.40

            if(edad >= 41 && edad <= 75  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.00

            if(edad >= 41 && edad <= 75  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.50
            return 0

        },

        setRegistraSeguro(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/tratar-data-cliente/registrar-seguro';

            axios.post(url, {
                'seguro_id' :               this.cliente_seguro.id,
                'clientes_data_id'   :      this.id,
                'tasa'               :      this.tasa_automatico

            }).then(res => {

                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                if(res.data.status){
                    this.clienteCotizar();
                    this.notify(" Seguro vinculado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    this.modal_show_aseguradora = false;
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })
        },

        tasas_seguro_agregar(){
            var me = this;
            var url = '/cotizacion/getlistSeguroTotal';

                axios.post(url,{'id': me.cliente_seguro.id})
                    .then(res => {
                        var respuesta = res.data;

                        me.arrayCotizacion.push({
                                seguro: respuesta.seguro,
                                dis_rastreo_aplica: false,
                                deducible: respuesta.deducible,
                                covertura: respuesta.covertura,
                                porcentaje_tasa: me.tasa_automatico,
                                auto_auto_aplica: false,
                                interes_financiamiento_por: 0,
                                interes_financiamiento: 0,
                                derecho_emicion: 0,
                                s_bancos_por: 3.50,
                                s_bancos: 0,
                                s_campesino_por: 0.50,
                                s_campesino: 0,
                                iva_por: this.iva_data,
                                iva_total: 0,
                                valor_pagar_vehiculo: 0,
                                desgravamen: 0,
                                total: 0,
                                seleccionar: false,

                        });

                        me.arrayPrimaNeta.push({
                            prima_neta: 0
                        });
                    })
                    .catch(err => {
                        console.log(err);
                        if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    })
            me.openCargando(true);

        },

        evaluar_derecho_emicion(primaNeta){

             var  emision = 0;

            if (primaNeta > 0 && primaNeta <= 250) {
            emision = 0.5;
            //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 251 && primaNeta <= 500) {
                emision = 1;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 501 && primaNeta <= 1000) {
                emision = 3;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 1001 && primaNeta <= 2000) {
                emision = 5;
            // primaNeta = primaNeta + emision;
            } else if (primaNeta >= 2001 && primaNeta <= 4000) {
                emision = 7;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 4001 && primaNeta <= 100000) {
                emision = 9;
                //primaNeta = primaNeta + emision;
            }
            return emision
        },


        evaluar_des_por(degravamen, porcen){
            // console.log(degravamen);
                if (degravamen == 0 && porcen == 0) {

                    return 0
                } else if (porcen == 0) {
                    return 150
                } else if (degravamen == 0) {
                    return 0
                } else if (porcen > 0) {
                    var  total = degravamen * porcen / 100;
                    if (total < 104.50) {

                        total = 104.50;
                        return total
                    }else{

                        return total
                    }

                }
        },

        registrarCotizacion(){

            var me = this;
            var veri = false;
            var url = '/cotizacion/registrar';
            this.openCargando();

            if (me.verificar_seleccion() > 1){
                me.openCargando(true);

                me.notify(" Seleccione solo un seguro a emitir","","top","right","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                return
            }
            //Evaluamos que el estado este en algunos de los mencionados
            //si esta, entonces evaluamos que solo este selecionado un seguro, de lo contrario mandamor error
            switch (me.vaCreCoti.estado) {
                case 'RECOLECION DE DOCUMENTOS':
                    veri = true;
                    break;
                case 'GESTION DE INSPECCION':
                    veri = true;
                    break;

                case 'GESTION DE EMISION':
                    veri = true;
                    break;
                case 'GESTION DE LIBERACION':
                    veri = true;
                    break;
                case 'PRELIQUIDACION':
                    veri = true;
                    break;
                default:
                    veri = false;
                    break;
            }

            if(veri == true){

                if (me.verificar_seleccion() == 1){

                }else{
                    me.openCargando(true);
                    me.notify(" Seleccione un seguro a emitir","","top","right","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                    return
                }
            }


            if (me.arrayCotizacion.length<=0){
                me.openCargando(true);
                me.notify(" Agregue almenos un seguro a cotizar","","top","right","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                return
            }



            axios.post(url, {

                'vaCreCoti': me.vaCreCoti,
                'arrayCotizacion' :me.arrayCotizacion,
                'arrayPrimaNeta' : me.arrayPrimaNeta,
                'clientes_data_id'   :      this.id,
            }).
            then(res => {


                if(res.data.status){

                    me.openCargando(true);
                    me.notify(" Cotización registrada con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    //me.cleanVariables();
                }else{
                    me.openCargando(true);
                    me.notify(" Ha ocurrido un error al registrar la Cotización","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                    console.error(res.data.mensaje);
                }

            })
            .catch(err => {
                me.openCargando(true);//Desactivamos ventana de carga de bloqueo

                for(var key in err.response.data.errors){
                    me.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }
                if(err.response.status == 401) {
                    if (localStorage['authUser']) {
                        me.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
                console.error(err);
             }
            )
        },

        verificar_seleccion(){
             var sw=0;
                for(var i=0;i<this.arrayCotizacion.length;i++){

                    if(this.arrayCotizacion[i].seleccionar==true){
                        sw++;
                    }
                }
                //console.log(sw);
               return sw;
        },




    },
    mounted(){
        this.clienteCotizar();
    }
}
</script>

<style>

</style>
